import {Component, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {MetaTagType} from "../../../../catalogue/meta-tag/meta-tag.data";
import {MixAndMatchData, MixAndMatchInclusionData} from "../../mix-and-match.data";

@Component({
    selector: "wbo-mix-and-match-inclusion-edit-form",
    styleUrls: ["./mix-and-match-inclusion-edit-form.component.scss"],
    templateUrl: "./mix-and-match-inclusion-edit-form.component.html"
})
export class MixAndMatchInclusionEditFormComponent {
    MetaTagType = MetaTagType;

    @Input() mixAndMatch: MixAndMatchData;
    @Input() inclusion: MixAndMatchInclusionData;
    @Input() formGroup: FormGroup;

    extraValueChange(value: any): void {
        if (value != undefined) {
            this.inclusion.extraCustomObject = null;
        }
    }

    extraCustomObjectValueChange(value: any): void {
        if (value != undefined) {
            this.inclusion.extra = null;
        }
    }

    discountableExtraValueChange(value: any): void {
        if (value != undefined) {
            this.inclusion.discountableExtraCustomObject = null;
        }
    }

    discountableExtraCustomObjectValueChange(value: any): void {
        if (value != undefined) {
            this.inclusion.discountableExtra = null;
        }
    }

    minExtraQtyChanged(value: number): void {
        if (this.inclusion.minExtraQty != undefined && this.inclusion.maxExtraQty != undefined && this.inclusion.maxExtraQty < this.inclusion.minExtraQty) {
            this.inclusion.maxExtraQty = this.inclusion.minExtraQty;
        }
    }

    maxExtraQtyChanged(value: number): void {
        if (this.inclusion.maxExtraQty != undefined && this.inclusion.minExtraQty != undefined && this.inclusion.minExtraQty > this.inclusion.maxExtraQty) {
            this.inclusion.minExtraQty = this.inclusion.maxExtraQty;
        }
    }

    get detailLabel(): String {
        return this.inclusion.sellable && this.inclusion.sellable.sellableId ? "wbo.mix-and-match.edit.field.inclusions.plu.label" : "wbo.mix-and-match.edit.field.inclusions.groupType.label";
    }

    get detailPlaceholder(): String {
        return this.inclusion.sellable && this.inclusion.sellable.sellableId ? "wbo.mix-and-match.edit.field.inclusions.plu.placeholder" : "wbo.mix-and-match.edit.field.inclusions.groupType.placeholder";
    }
}
